import { makeVar } from '@apollo/client';

export const userNameVar = makeVar('');
